import Modal from 'react-bootstrap/Modal';
import { Button, DatePicker, message, Spin, Flex, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import UserModel from "../../../models/UserModel";
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from "prop-types";
import swal from "../../reusable/CustomSweetAlert";
import Admin from 'models/AdminModel';
import { useHistory } from "react-router-dom";
import Placeholder from 'utils/Placeholder';

UserFormModal.propTypes = {
    close: PropTypes.func,
    isOpen: PropTypes.bool,
    isNewRecord: PropTypes.bool,
    userData: PropTypes.object,
    isSuperAdmin: PropTypes.bool,
};


export default function UserFormModal({ isOpen, close, isNewRecord, userData, isSuperAdmin }) {
    const history = useHistory()
    const [form] = Form.useForm()

    const userRoles = [
        { label: "Admin", value: "ADMIN" },
        { label: "Admin TFP", value: "ADMIN_TFP" },
        { label: "Admin Redaksi", value: "ADMIN_REDAKSI" },
        { label: "Super Admin", value: "SUPERADMIN" },
    ];

    const [loadingUpload, setLoadingUpload] = useState(false)


    const onSubmit = async () => {
        try {
            let result;
            let body = form.getFieldsValue();
            let msg = ''
            console.log(body)
            if (isNewRecord) {
                if (body.role == "ADMIN") {
                    await Admin.createAdmin(body);
                } else if (body.role === 'SUPERADMIN') {
                    await Admin.createSuperAdmin(body);
                } else {
                    await Admin.create(body);
                }
                msg = "Successfully added new User"
            } 
            // else {
            //     if (isSuperAdmin) {
            //         await Admin.edit(userData?.id, body)
            //     } else {
            //         await Admin.editSelf(body);
            //     }
            //     msg = "Successfully updated User"
            // }

            message.success(msg)
            handleClose(true)
        } catch (e) {
            console.log(e)
            let errorMessage = "An Error Occured"
            await swal.fire({
                title: 'Error',
                text: e.error_message ? e.error_message : errorMessage,
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }

    }

    const handleClose = (refresh) => {
        close(refresh)
    }

    const initForm = () => {
        console.log('isi userData', userData)
        if (!isNewRecord) {
            form.setFieldsValue({
                username: userData?.username,
                role: userData?.role,
            })
        }

    }
    useEffect(() => {
        if (isNewRecord) {
            reset()
        } else {
            initForm()
        }


    }, [isOpen])

    const reset = () => {
        form.resetFields();
    }

    return <Modal
        show={isOpen}
        backdrop="static"
        keyboard={false}
    >
        <Modal.Header style={{ paddingBottom: "0" }}>
            <div className={'d-flex w-100 justify-content-between'}>
                {/* <Modal.Title>{isNewRecord ? 'Create User' : `Update User`}</Modal.Title> */}
                <Modal.Title>Add User</Modal.Title>
                <Button onClick={() => {
                    close()
                }} style={{ position: 'relative', top: -5, color: '#fff', fontWeight: 800 }} type="link" shape="circle"
                    icon={<CloseOutlined />} />
            </div>
        </Modal.Header>
        <Modal.Body style={{ paddingTop: "0" }}>
            <Form
                layout='vertical'
                form={form}
                onFinish={onSubmit}
                validateTrigger="onSubmit"
                autoComplete="off"
            >
                <Form.Item
                    label={"Username"}
                    name={"username"}
                    rules={[{
                        required: true,
                    }]}
                >
                    <Input variant='filled' placeholder={Placeholder.name_person} />
                </Form.Item>
                {isNewRecord ? (
                    <>
                        <Form.Item
                            label={"Role"}
                            name={"role"}
                            rules={[{
                                required: true,
                            }]}
                        >
                            <Select variant='filled' options={userRoles} placeholder={Placeholder.admin_role} />
                        </Form.Item>
                        <Form.Item
                            label={"Password"}
                            name={"password"}
                            rules={[{
                                required: true,
                            }]}
                        >
                            <Input.Password variant='filled' placeholder={Placeholder.password} />
                        </Form.Item>
                        <Form.Item
                            label={"Confirm Password"}
                            name={"confirm_password"}
                            rules={[
                                {
                                    required: true,
                                    message: ""
                                },
                                {
                                    validator: async (_, value) => {
                                        if (!form.getFieldValue("password")) return Promise.reject("Please enter Password");
                                        if (!value) return Promise.reject("Please confirm your password");
                                        if (value !== form.getFieldValue("password")) {
                                            return Promise.reject("Password confirmation does not match")
                                        }
                                    }
                                }
                            ]}
                        >
                            <Input.Password variant='filled' placeholder={Placeholder.password_confirm} />
                        </Form.Item>
                    </>
                ) : (
                    <></>
                )}

                <div className={"d-flex flex-row justify-content-end"}>
                    <Form.Item>
                        <Button className={'text-white'} type={'link'} size="sm" variant="outline-danger"
                            onClick={() => handleClose()} style={{ marginRight: '5px' }}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button size="sm" type='primary' variant="primary" htmlType='submit'>
                            {/* {isNewRecord ? 'Add' : 'Save'} */}
                            Add
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal.Body>
    </Modal>
}
